module.exports = __webpack_public_path__ + "static/media/father.96c6b51c.jpg";